import { cityAirportData } from "src/interfaces";
import { fetch } from "./http";
import { getUniqueListBy } from "src/helpers";
import axios from "axios";

const controller: string = "v1/reference-data/";

export const fetchAirportsCities = async (keyword = "") => {
  try {
    const formData = new FormData();
    formData.append("search", keyword);

    const response = await axios.post(
      `${process.env.BACKEND_URL}locations`,
      formData
    );

    if (response.status === 200) {
      const responseData: any = response.data;
      // Flight search needs IATA codes; drop entries without one
      const withIata = (responseData?.data || []).filter(
        (item: cityAirportData) => item?.iataCode
      );
      const list = getUniqueListBy(withIata, "iataCode");
      return { ...responseData, data: list };
    } else if (response.status === 201) {
      throw new Error(response.data);
    } else if (response?.status != 429 && response?.status != 401) {
      throw new Error("Something went wrong");
    }
  } catch (error) {
    throw error;
  }
};
export const fetchAirportCityDetail = async (code: string, token: string) => {
  try {
    const response = await fetch.Get(controller + `locations/${code}`, token);
    if (response.status === 200) {
      const data = await response.json();
      return data;
    }
  } catch (error) {}
};
